import api from "./api";

export function getProductByIdService(id: any) {
    return api.get('/products/'+id)
}
